import { render, staticRenderFns } from "./RepoTreeFolder.vue?vue&type=template&id=f3f2d5f2&scoped=true"
import script from "./RepoTreeFolder.vue?vue&type=script&lang=js"
export * from "./RepoTreeFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f2d5f2",
  null
  
)

export default component.exports